export const APP_VERSION = '1.5.0 3.1.0';

export const ENABLE_REDUX_DEV_TOOLS = process.env.NODE_ENV==='development';

export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE'
};
